export interface IUserProfileUpdated {
  result: boolean
}

export interface IUserProfile {
  legacyUserId: string
  azureB2CId: string
  titleId?: string
  crn: string
  title?: string
  firstName: string
  lastName: string
  password: string
  pin: number
  genderId?: string
  customerTypeId: string
  phone?: string
  emailAddress: string
  businessName?: string
  businessABN?: string
  industryId?: string
  subIndustryId?: string
  businessLocationId?: string
  noOfEmployees?: string
  whatDescribesBusinessId?: string
  coveredByAwardsId?: string
  modernAwardsId?: string
  agreementNameOrCode?: string
  userWorkplaceType: number
  resourceUserType: number
  createdDate?: string
  updatedDate?: string
  id: string
  govCMSIndustryFilterId?: string
  govCMSSubIndustryFilterId?: string
  businessCoveredId?: string
  requiresRegistration: boolean

  businessDescriptions: any[]
  yesNoUnsure: any[]
  modernAwards: any[]
  titles: any[]
  genders: any[]
  customerTypes: any[]
  regions: any[]
  awardIndustries: any[]
  awardSubIndustries: any[]
}

export class UserProfile implements IUserProfile {
  legacyUserId = ''
  azureB2CId = ''
  titleId?: string = ''
  crn = ''
  firstName = ''
  lastName = ''
  password = ''
  pin = 0
  genderId?: string = ''
  customerTypeId = ''
  phone?: string = ''
  emailAddress = ''
  businessName?: string = ''
  businessABN?: string = ''
  industryId?: string = ''
  subIndustryId?: string = ''
  businessLocationId?: string = ''
  noOfEmployees?: string = ''
  whatDescribesBusinessId?: string = ''
  coveredByAwardsId?: string = ''
  modernAwardsId?: string = ''
  businessCoveredId?: string = ''
  agreementNameOrCode?: string = ''
  userWorkplaceType: number
  resourceUserType: number
  createdDate?: string = ''
  updatedDate?: string = ''
  id = ''
  govCMSIndustryFilterId?: string = ''
  govCMSSubIndustryFilterId?: string = ''
  requiresRegistration = false

  businessDescriptions: any[] = []
  yesNoUnsure: any[] = []
  modernAwards: any[] = []
  titles: any[] = []
  genders: any[] = []
  customerTypes: any[] = []
  regions: any[] = []
  awardIndustries: any[] = []
  awardSubIndustries: any[] = []

  constructor(init?: UserProfileFormValues) {
    Object.assign(this, init)
  }
}

export class UserProfileFormValues {
  legacyUserId = ''
  azureB2CId = ''
  titleId?: string = ''
  crn = ''
  firstName = ''
  lastName = ''
  password = ''
  pin = 0
  genderId?: string = ''
  customerTypeId = ''
  phone?: string = ''
  emailAddress = ''
  businessName?: string = ''
  businessABN?: string = ''
  industryId = ''
  subIndustryId = ''
  businessLocationId = ''
  noOfEmployees?: string = ''
  whatDescribesBusinessId?: string = ''
  coveredByAwardsId?: string = ''
  modernAwardsId?: string = ''
  businessCoveredId?: string = ''
  agreementNameOrCode?: string = ''
  userWorkplaceType: number
  resourceUserType: number
  createdDate?: string = ''
  updatedDate?: string = ''
  id = ''
  requiresRegistration = false

  businessDescriptions: any[] = []
  yesNoUnsure: any[] = []
  modernAwards: any[] = []
  titles: any[] = []
  genders: any[] = []
  customerTypes: any[] = []
  regions: any[] = []
  awardIndustries: any[] = []
  awardSubIndustries: any[] = []

  constructor(profileDetail?: UserProfileFormValues) {
    if (profileDetail) {
      this.legacyUserId = profileDetail.legacyUserId
      this.azureB2CId = profileDetail.azureB2CId
      this.titleId = profileDetail.titleId
      this.crn = profileDetail.crn
      this.firstName = profileDetail.firstName
      this.lastName = profileDetail.lastName
      this.password = profileDetail.password
      this.pin = profileDetail.pin
      this.genderId = profileDetail.genderId
      this.customerTypeId = profileDetail.customerTypeId
      this.phone = profileDetail.phone
      this.emailAddress = profileDetail.emailAddress
      this.businessName = profileDetail.businessName
      this.businessABN = profileDetail.businessABN
      this.industryId = profileDetail.industryId
      this.subIndustryId = profileDetail.subIndustryId
      this.businessLocationId = profileDetail.businessLocationId
      this.noOfEmployees = profileDetail.noOfEmployees
      this.whatDescribesBusinessId = profileDetail.whatDescribesBusinessId
      this.coveredByAwardsId = profileDetail.coveredByAwardsId
      this.modernAwardsId = profileDetail.modernAwardsId
      this.businessCoveredId = profileDetail.businessCoveredId
      this.agreementNameOrCode = profileDetail.agreementNameOrCode
      this.userWorkplaceType = profileDetail.userWorkplaceType
      this.resourceUserType = profileDetail.resourceUserType
      this.createdDate = profileDetail.createdDate
      this.updatedDate = profileDetail.updatedDate
      this.id = profileDetail.id
      this.requiresRegistration = profileDetail.requiresRegistration

      this.businessDescriptions = profileDetail.businessDescriptions
      this.yesNoUnsure = profileDetail.yesNoUnsure
      this.modernAwards = profileDetail.modernAwards
      this.titles = profileDetail.titles
      this.genders = profileDetail.genders
      this.customerTypes = profileDetail.customerTypes
      this.regions = profileDetail.regions
      this.awardIndustries = profileDetail.awardIndustries
      this.awardSubIndustries = profileDetail.awardSubIndustries
    }
  }
}

export class UserProfileRequest {
  titleId?: string
  firstName: string
  lastName: string
  genderId?: string
  customerTypeId: string
  phone?: string
  emailAddress: string
  businessName?: string
  businessABN?: string
  industryId?: string
  subIndustryId?: string
  businessLocationId?: string
  noOfEmployees?: string
  whatDescribesBusinessId?: string
  coveredByAwardsId?: string
  modernAwardsId?: string
  agreementNameOrCode?: string
  businessCoveredId?: string

  constructor(init?: UserProfile) {
    if (init) {
      this.titleId = init.titleId
      this.firstName = init.firstName
      this.lastName = init.lastName
      this.genderId = init.genderId
      this.customerTypeId = init.customerTypeId
      this.phone = init.phone
      this.emailAddress = init.emailAddress
      this.businessName = init.businessName
      this.businessABN = init.businessABN
      this.industryId = init.industryId
      this.subIndustryId = init.subIndustryId
      this.businessLocationId = init.businessLocationId
      this.noOfEmployees = init.noOfEmployees
      this.whatDescribesBusinessId = init.whatDescribesBusinessId
      this.coveredByAwardsId = init.coveredByAwardsId
      this.modernAwardsId = init.modernAwardsId
      this.agreementNameOrCode = init.agreementNameOrCode
      this.businessCoveredId = init.businessCoveredId
    }
  }
}

export class RegisterUserRequest {
  emailAddress: string
  firstName: string
  lastName: string
  customerTypeId: string
  industryId?: string
  subIndustryId?: string
  businessLocationId?: string
  phone?: string

  constructor(init?: UserProfile) {
    if (init) {
      this.emailAddress = init.emailAddress
      this.firstName = init.firstName
      this.lastName = init.lastName
      this.customerTypeId = init.customerTypeId
      this.industryId = init.industryId
      this.subIndustryId = init.subIndustryId
      this.businessLocationId = init.businessLocationId
      this.phone = init.phone
    }
  }
}

export const ProfileFieldMapping = new Map<string, string>([
  ['titleId', 'Title'],
  ['firstName', 'First name'],
  ['lastName', 'Last name'],
  ['genderId', 'Gender'],
  ['customerTypeId', 'Customer type'],
  ['emailAddress', 'Email address'],
  ['crn', 'CRN (Customer reference Number)'],
  ['phone', 'Contact phone number'],
  ['businessName', 'Business name'],
  ['businessABN', 'ABN (Australian Business Number)'],
  ['industryId', 'Business industry'],
  ['subIndustryId', 'Sub industry'],
  ['businessLocationId', 'Location of business'],
  ['noOfEmployees', 'How many employees does this business have?'],
  ['whatDescribesBusinessId', 'What else describes the business?'],
  [
    'businessCoveredId',
    'Do you know which modern award the business is covered by?',
  ],
  ['modernAwardsId', 'Award'],
  [
    'coveredByAwardsId',
    'Is the business or its employees covered by any other awards or registered agreements (AWA, ITEA, collective or enterprise agreement) or Fair Work Commission Order?',
  ],
  ['agreementNameOrCode', 'Name or code of award or agreement or order'],
])
